/*
	After some async processes, we sometimes receive notifications that there are new Versions
	imported to a library, so we will dispatch a reload.
*/

import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { useOnMountFTMessage } from "hooks/Notification";

import { CreativeVersions } from "reducers/CreativeVersions";
import { CreativeDetails } from "reducers/CreativeDetails";

import { JCRM_SOCKET } from "utils/constants";

export function useVersionsSocket(){
	const dispatch = useDispatch();
	const { libraryId, creativeId } = useParams();

	useOnMountFTMessage(({ detail }) => {
		let { message } = detail;

		if(message.origin === JCRM_SOCKET){
			if(!/success/gi.test(message.status)){ return; }

			if (/import versions/gi.test(message.task)) {
				if (!message.data?.response?.changes?.creatives) { return; }

				const { creatives } = message.data.response.changes;

				if (creatives.length !== 1) { return; }

				const reqLibraryId = message.data?.creativeLibrary?.id;
				const reqCreativeId = creatives[0].id;

				if (parseInt(libraryId) !== reqLibraryId) { return; }
				if (parseInt(creativeId) !== reqCreativeId) { return; }

				dispatch(CreativeVersions.loadCreativeVersions(reqLibraryId, reqCreativeId));
				dispatch(CreativeDetails.loadCreative(reqCreativeId));
			}
		}
	});
}

export function VersionsSocketListener({ children }){
	useVersionsSocket();

	return children;
}
